var React = require('react');

function IconSocialLink (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#242424","fillOpacity":".3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.025 17.06a3 3 0 010-4.242l4.243-4.243a3 3 0 014.242 0l1.415 1.415a3 3 0 010 4.242l-2.122 2.122-1.414-1.415 2.122-2.121a1 1 0 000-1.414L20.096 9.99a1 1 0 00-1.414 0l-4.243 4.242a1 1 0 000 1.414l.707.707-1.414 1.415-.707-.707z","fill":"#fff","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.975 14.94a3 3 0 010 4.242l-4.243 4.243a3 3 0 01-4.242 0L8.075 22.01a3 3 0 010-4.242l2.122-2.122 1.414 1.415-2.121 2.121a1 1 0 000 1.414l1.414 1.414a1 1 0 001.414 0l4.243-4.242a1 1 0 000-1.414l-.707-.707 1.414-1.415.707.707z","fill":"#fff","key":2})]);
}

IconSocialLink.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = IconSocialLink;

IconSocialLink.default = IconSocialLink;
